import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';
import { Version } from 'src/app/proto/generated/inv_common_message_pb';
import { InventoryBase } from './inventory-base.model';

export class InventoryVersion extends InventoryBase {
  work_order_name: string;
  version: number;
  json_data: any;
  is_selected: boolean;
  created_on: Date;

  static MapperList(source: Version[]): InventoryVersion[] {
    const versions: InventoryVersion[] = [];

    for (const version of source) {
      versions.push(this.Mapper(version));
    }

    return versions;
  }

  static Mapper(source: Version): InventoryVersion {
    const destination: InventoryVersion = new InventoryVersion();
    destination.created_on = source.getCreatedOn().toDate();
    destination.FsrIdentifier = source.getFsrName();
    destination.version = source.getVersion();

    const jsonObj = JSON.parse(source.getJsonData());
    for (const prop in jsonObj) {
      if (typeof jsonObj[prop] === 'object') {
        for (const internalProp in jsonObj[prop]) {
          destination[internalProp] = jsonObj[prop][internalProp];
        }
      } else {
        destination[prop] = jsonObj[prop];
      }
    }

    destination.work_order_name = source.getInventoryName();
    destination.json_data = JSON.parse(source.getJsonData());
    destination.AssignedTo = source.getAssignedTo();
    destination.AuditorName = source.getAuditorName();
    destination.Audited = source.getAudited();
    destination.is_selected = source.getIsSelected();
    destination.name = source.getName();

    return destination;
  }

  static MapperProtoList(source: InventoryVersion[]): Version[] {
    const destination: Version[] = [];

    for (const version of source) {
      destination.push(InventoryVersion.MapperProto(version));
    }

    return destination;
  }

  static MapperProto(source: InventoryVersion): Version {
    const destination: Version = new Version();

    destination.setInventoryName(source.work_order_name);
    destination.setJsonData(JSON.stringify(source.json_data));
    destination.setFsrName(source.FsrIdentifier);
    destination.setAssignedTo(source.AssignedTo);
    destination.setVersion(source.version);
    destination.setAudited(source.Audited);
    destination.setAuditorName(source.AuditorName);
    destination.setIsSelected(source.is_selected);
    destination.setCreatedOn(Timestamp.fromDate(source.created_on));
    destination.setName(source.name);
    return destination;
  }
}
